/**
 * Carries the first message a visitor types into the landing-page hero
 * composer across the navigation to /chat, where it's sent automatically.
 *
 * sessionStorage, not localStorage: this is a one-shot handoff for the
 * current tab, not something that should resurface on a later visit.
 */
const PENDING_KEY = "memnora-pending-message";

export function setPendingMessage(text: string): void {
  try {
    sessionStorage.setItem(PENDING_KEY, text);
  } catch {
    // Private mode / storage disabled — worst case the message is retyped.
  }
}

/** Reads and clears the pending message, if any. */
export function consumePendingMessage(): string | null {
  try {
    const value = sessionStorage.getItem(PENDING_KEY);
    if (value) sessionStorage.removeItem(PENDING_KEY);
    return value;
  } catch {
    return null;
  }
}
